import React, { useState } from 'react';
import { Button } from '../ui/button';
import { User, Frown, Heart, Smile, Meh, Eye } from 'lucide-react';

const PersonalityAttributesStep = ({ data, updateData, onNext }) => {
  const [selected, setSelected] = useState(data.personalityAttributes || []);

  const attributes = [
    { id: 'shy', label: 'Shy', icon: User },
    { id: 'pessimistic', label: 'Pessimistic', icon: Frown },
    { id: 'flirty', label: 'Flirty', icon: Heart },
    { id: 'optimistic', label: 'Optimistic', icon: Smile },
    { id: 'ordinary', label: 'Ordinary', icon: Meh },
    { id: 'mysterious', label: 'Mysterious', icon: Eye }
  ];

  const handleToggle = (attrId) => {
    setSelected(prev => {
      if (prev.includes(attrId)) {
        const updated = prev.filter(id => id !== attrId);
        updateData('personalityAttributes', updated);
        return updated;
      } else if (prev.length < 3) {
        const updated = [...prev, attrId];
        updateData('personalityAttributes', updated);
        return updated;
      }
      return prev;
    });
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        Select personality attributes
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        Choose up to 3
      </p>

      <div className="grid grid-cols-2 gap-4 mb-8">
        {attributes.map((attr) => {
          const IconComponent = attr.icon;
          const isSelected = selected.includes(attr.id);
          return (
            <button
              key={attr.id}
              onClick={() => handleToggle(attr.id)}
              disabled={!isSelected && selected.length >= 3}
              className={`py-6 px-4 rounded-2xl text-base md:text-lg font-bold transition-all duration-300 hover:scale-105 flex flex-col items-center justify-center gap-2 ${
                isSelected
                  ? 'bg-[#F1B428] text-black shadow-lg shadow-[#F1B428]/30 scale-105'
                  : 'bg-white/5 backdrop-blur-sm text-white border border-white/10 hover:border-[#F1B428]/50 disabled:opacity-30 disabled:cursor-not-allowed'
              }`}
            >
              <IconComponent size={24} />
              {attr.label}
            </button>
          );
        })}
      </div>

      <Button
        onClick={onNext}
        disabled={selected.length === 0}
        className="w-full max-w-sm bg-[#F1B428] hover:bg-[#D9A022] text-black font-bold text-lg py-6 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-[#F1B428]/30 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Continue
      </Button>
    </div>
  );
};

export default PersonalityAttributesStep;
